import React from 'react';
import PropTypes from 'prop-types';
import Reviews from 'components/Reviews';
import './index.scss';

/*
 * Type definitions
 */
const propTypes = {
    handle: PropTypes.string.isRequired,
    backgroundImage: PropTypes.string,
    tripAdvisor: PropTypes.string,
    googleReview: PropTypes.string,
};

const defaultProps = {
    backgroundImage: '',
    tripAdvisor: '',
    googleReview: '',
};

/*
 * Component
 */
function InstagramHandle({
    handle,
    backgroundImage,
    tripAdvisor,
    googleReview
}) {
    if (!handle) {
        return null;
    }

    return (
        <div
            className="instagram-handle"
            style={{
                backgroundImage: backgroundImage ? `url("${backgroundImage}")` : null
            }}
        >
            <a
                href={`https://www.instagram.com/explore/tags/${handle}`}
                target="_blank"
                rel="noopener noreferrer"
            >
                {`#${handle}`}
            </a>
            <Reviews
                googleReviewsUrl={googleReview}
                tripAdvisorUrl={tripAdvisor}
            />
        </div>
    );
}

InstagramHandle.propTypes = propTypes;
InstagramHandle.defaultProps = defaultProps;

export default InstagramHandle;
